/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

interface Props {
	show: boolean;
	onClose: () => void;
	onConfirm: () => void;
	actionType: "approve" | "reject";
}


const ConfirmModal = ({ show, onClose, onConfirm, actionType }: Props) => {
	const handleConfirm = () => {
		onConfirm();
		onClose();
	};
	return (
		<div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/60 backdrop-blur-sm animate-in fade-in duration-300">
			<div className="bg-white rounded-3xl shadow-2xl w-full max-w-md overflow-hidden animate-in zoom-in-95 duration-300">
				<div
					className={`h-2 ${actionType === "approve" ? "bg-emerald-500" : "bg-red-500"}`}
				></div>
				<div className="p-8 text-center">
					<div
						className={`w-16 h-16 rounded-full mx-auto mb-6 flex items-center justify-center ${actionType === "approve" ? "bg-emerald-50 bg-emerald-100" : "bg-red-50 text-red-500"}`}
					>
						<span className="material-symbols-outlined text-3xl">
							{actionType === "approve" ? "verified" : "report_problem"}
						</span>
					</div>
					<h3 className="text-xl font-black text-slate-800 mb-2 uppercase tracking-tight">
						{actionType === "approve"
							? "Confirm Batch Release"
							: "Confirm Batch Rejection"}
					</h3>
					<p className="text-sm text-slate-500 leading-relaxed mb-8">
						{actionType === "approve"
							? "Are you sure you want to approve and release this batch? This action will generate the final certificate and update inventory."
							: "Are you sure you want to reject this batch? This action is permanent and will flag the batch as non-compliant."}
					</p>
					<div className="flex gap-3">
						<button
							onClick={onClose}
							className="flex-1 px-6 py-3 rounded-xl border border-slate-200 text-slate-400 font-black text-xs uppercase tracking-widest hover:bg-slate-50 transition-all"
						>
							Cancel
						</button>
						<button
							onClick={handleConfirm}
							className={`flex-1 px-6 py-3 rounded-xl text-white font-black text-xs uppercase tracking-widest shadow-lg transition-all active:scale-95 ${
								actionType === "approve"
									? "bg-emerald-500 shadow-emerald-500/20 hover:bg-emerald-600"
									: "bg-red-500 shadow-red-500/20 hover:bg-red-600"
							}`}
						>
							Confirm{" "}
							{actionType === "approve" ? "Release" : "Rejection"}
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ConfirmModal;
